import {
  HAND_PATH,
  HAND_VIEWBOX,
  LOGO_HAND_TRANSFORM,
  LOGO_VIEWBOX,
  LOGO_WORDMARK_TRANSFORM,
  WORDMARK_PATH,
} from './greetMarkPaths';

type MarkProps = {
  className?: string;
  /** Accessible name. Leave empty when a visible label sits next to it. */
  title?: string;
};

/** The GreetAI hand alone. Colour follows `currentColor`. */
export function GreetMark({ className, title = 'GreetAI' }: MarkProps) {
  return (
    <svg
      viewBox={HAND_VIEWBOX}
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}>
      <path fillRule="evenodd" clipRule="evenodd" fill="currentColor" d={HAND_PATH} />
    </svg>
  );
}

type LogoProps = MarkProps & {
  /** Colour of the hand; the wordmark uses `currentColor`. Defaults to `currentColor` too. */
  handColor?: string;
};

/** The hand plus "greet". Size it by height, e.g. `h-6 w-auto`. */
export function GreetLogo({ className, title = 'GreetAI', handColor = 'currentColor' }: LogoProps) {
  return (
    <svg
      viewBox={LOGO_VIEWBOX}
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}>
      <path
        transform={LOGO_HAND_TRANSFORM}
        fillRule="evenodd"
        clipRule="evenodd"
        fill={handColor}
        d={HAND_PATH}
      />
      <path transform={LOGO_WORDMARK_TRANSFORM} fill="currentColor" d={WORDMARK_PATH} />
    </svg>
  );
}
